import { ReactNode } from 'react';
import { ReactComponent as CloseIcon } from '../../../images/close-btn.svg';

type FlagsFullscreenOverlayProps = {
  isFlagsMobileViewOpen: boolean;
  isFromPdfViewerPage: boolean;
  setIsFlagsMobileViewOpen: (isOpen: boolean) => void;
  component: ReactNode;
};

export function FlagsFullscreenOverlay({
  isFlagsMobileViewOpen,
  setIsFlagsMobileViewOpen,
  isFromPdfViewerPage,
  component
}: FlagsFullscreenOverlayProps) {
  return (
    <div
      style={{
        position: 'fixed',
        top: '55vh',
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        background: isFlagsMobileViewOpen ? '#000000d8'
:          'linear-gradient(170deg, rgb(3 19 65) 0%, rgb(6, 6, 6) 18%, rgba(0, 0, 6, 1) 50%, rgb(3, 21, 75) 95%)',
        zIndex: 1000,
        padding: 8,
        transform: isFlagsMobileViewOpen ? 'translateX(0)' : 'translateX(100%)',
        transition: 'transform 160ms ease-out'
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignSelf: 'stretch',
          gap: 8
        }}
      >
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            alignSelf: 'stretch',
            height: isFromPdfViewerPage ? 0 : 'auto'
          }}
        >
          {!isFromPdfViewerPage && (
            <CloseIcon
              onClick={() => setIsFlagsMobileViewOpen(false)}
              fill="#7d7d7f"
              height="36"
            />
          )}
        </div>

        <div>{component}</div>
      </div>
    </div>
  );
}
